module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('button', {
    staticClass: "button is-small is-info",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("Show / Hide")]), _vm._v(" "), (_vm.show) ? _c('div', [_vm._t("filter"), _vm._v(" "), _vm._t("graph"), _vm._v(" "), _c('div', {
    staticClass: "table__wrapper"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('thead', _vm._l((_vm.headers), function(heading) {
    return _c('th', {
      key: heading
    }, [_vm._v("\n              " + _vm._s(heading) + "\n            ")])
  }), 0), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(row) {
    return _c('tr', {
      key: row.id
    }, _vm._l((row), function(data) {
      return _c('td', {
        key: data.id
      }, [_vm._v(_vm._s(data))])
    }), 0)
  }), 0)])])], 2) : _vm._e(), _vm._v(" "), _vm._t("situational"), _vm._v(" "), _vm._t("average_game"), _vm._v(" "), _vm._t("average_sixty")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0daf947b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/data-table.vue
// module id = 582
// module chunks = 30